import pipeDeteriorationApi from '@Apis/pipeDeterioration.api';
import {
	GetAllFailureDefinitionsResponse,
	GetDeteriorationModelsResponse,
	GetAllDeteriorationModelsResponse,
	SingleDeteriorationModelResponse,
} from '@Types/pipeDeterioration.types';
import { getTenantId } from '@innovyze/lib_get_service';
import { AxiosResponse } from 'axios';

export const getFailureDefinitions = (
	systemType?: string,
	assetType?: string,
) => {
	const tenantId = getTenantId();
	return pipeDeteriorationApi.get<GetAllFailureDefinitionsResponse>(
		'failure-definitions',
		{
			params: {
				published: true,
				...(systemType && { system_type: systemType }),
				...(assetType && { asset_type: assetType }),
			},
			headers: {
				'x-tenant-id': tenantId,
			},
		},
	);
};

export const getDeteriorationModels = async (
	systemType?: string,
	assetType?: string,
): Promise<AxiosResponse<GetAllDeteriorationModelsResponse>> => {
	const tenantId = getTenantId();
	const allModels: SingleDeteriorationModelResponse[] = [];
	let currentPage = 1;
	const pageSize = 100;
	let hasMorePages = true;

	while (hasMorePages) {
		const response =
			await pipeDeteriorationApi.get<GetDeteriorationModelsResponse>(
				'deterioration-models',
				{
					params: {
						page: currentPage,
						slice: pageSize,
						sort_key: 'created_at',
						sort_descending: true,
						active_only: true,
						published: true,
						...(systemType && { system_type: systemType }),
						...(assetType && { asset_type: assetType }),
					},
					headers: {
						'x-tenant-id': tenantId,
					},
				},
			);

		allModels.push(...response.data.data);

		const { page, slice, total } = response.data.pagination;
		const totalPages = Math.ceil(total / slice);
		hasMorePages = page < totalPages;
		currentPage++;
	}

	return {
		data: {
			data: allModels,
		},
	} as AxiosResponse<GetAllDeteriorationModelsResponse>;
};
